module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p_raggedright",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("It was cold, but not bitterly so, and Seb hesitated only a moment before asking if Matty wanted to sit a bit before heading home. His original rudeness with Matty regarding his family continued to ping his conscience. With a smile Matty agreed and settled on the top step, arms resting on his knees.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("Seb rubbed the knees of his jeans. “I wanted to thank you for suggesting that the girls let me read to them. They aren’t…. Well, they need some time to get used to me being around.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("“You don’t have to thank me for that. It’s important that they get to know you. Family is important.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("“Do you get to see your parents much? Do they visit?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("Mouth set in a hard line, Matty looked like he was considering his answer. “Not really. They gave me the house. Wanted me to make a go of the workshop.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("“That was nice of them,” Seb said, fighting the question in his tone.")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("“It was. I get that. I don’t want to seem ungrateful. How many artists my age have a setup like mine that’s basically free?” He crossed his arms. “It’s their way of showing love. Best they can do. I’ve learned to understand that.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("“So you found another family?” Seb flinched after the words came out, realizing how it sounded. “I’m sorry—I didn’t mean….”")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("“It’s okay. I know it was weird when you walked in the door and heard the girls calling me Uncle Matt. Especially with our… history… and the fact that we haven’t talked in years.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("Face heating, Seb squirmed on the cool wooden step.")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("Matty straightened his back and held Seb’s gaze with growing intensity. Inching closer, he raised his hand to Seb’s cheek. Matty’s fingers felt warm against his chilled skin.")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("“You grew up fine,” Matty murmured. “Is this okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_raggedright"
  }, [_vm._v("Pulled by an invisible string, Seb nodded and closed the gap. The kiss was gentle, exploring but fearless. Like a whisper made flesh. He inhaled and licked his lips before tilting his head and letting the soft kiss deepen to a happy "), _c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Oh yes. I remember this. Remember you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98b7042e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0003.vue
// module id = 63
// module chunks = 0